import { iconesBeneficios } from "./icones-beneficios.css";

export function IconesBeneficios({ ...rest }) {
  return <span className={iconesBeneficios} {...rest}></span>;
}
